function handleTelephonePaste(form, e) {
    var text = (e.originalEvent || e).clipboardData.getData('text/plain');
    text = text.replaceAll(/\s/g, '');
    text = text.replaceAll(/[^\d]/g, '');
    var match = text.match(/0(\d{4})(\d{6})/);
    if (match) {
        e.preventDefault();
        e.currentTarget.value = "+44 ".concat(match[1], " ").concat(match[2]);
        form.setData('telephone', e.currentTarget.value);
    }
}
export { handleTelephonePaste };
